var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 9,
    fill: "#f25022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 9,
    height: 9,
    fill: "#7fba00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11,
    width: 9,
    height: 9,
    fill: "#00a4ef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 9,
    height: 9,
    fill: "#ffb900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.91534121f158812a09544611fdcb6fac.svg";
export { ForwardRef as ReactComponent };